/**
 * Given an array of objects that contain an isDefault property, returns the first member with
 * isDefault = true, or undefined.
 */
export const getDefaultObject = arr => arr.find(o => o.isDefault);